import { css } from '@emotion/react';

export const root = (width: string | undefined, isWidth: boolean, border?: string) => css`
  ${isWidth ? `width: ${width || '33.5rem'};` : `max-width: ${width || '33.5rem'};`}
  position: relative;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border: 0.1rem solid var(--color-foreground-neutral);
    ${border && `border: ${border}`};
    border-radius: 0.4rem;
    transition: border-color 0.3s linear, background-color 0.3s linear;
    pointer-events: none;
  }

  /* focus */
  &:focus-within {
    &::before {
      border-width: 0.2rem;
      border-color: var(--color-primary-default) !important;
    }
  }

  /* disabled */
  &[aria-disabled='true'] {
    background-color: var(--color-background-light);
    &::before {
      border-color: var(--color-background-disabled);
    }
  }

  /* invalid */
  &[aria-invalid='true'] {
    &::before {
      border-width: 0.2rem;
      border-color: var(--color-secondary-default);
    }
  }
`;

export const select = (background?: string, height?: string) => css`
  width: 100%;
  height: ${height};
  padding: 0 4.2rem 0 1.6rem;
  background: ${background || 'transparent'};
  appearance: none;
  border: 0;
  outline: none;
  font-family: inherit;
  font-size: 1.6rem;
  color: inherit;
`;

export const icon = css`
  height: 2.4rem;
  position: absolute;
  top: 0;
  right: 1.2rem;
  bottom: 0;
  margin: auto;
  pointer-events: none;
`;

export const width = (width: string | undefined) => css`
  ${width ? `width: ${width || '33.5rem'};` : ``}
`;
